.root {
	cursor: grab;
	padding: 0;
	margin: 0;

	&:hover {
		.icon {
			opacity: 1;
		}
	}
}

.icon {
	opacity: 0.4;
}
